module.exports = __webpack_public_path__ + "img/wechat-test-open.45aa53a2.jpg";